import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/ui-kit";
import { toast, Toaster } from "sonner";
import { Recycle, Hand, MapPin, ChevronRight } from "lucide-react";

export default function PotCommun() {
  const navigate = useNavigate();
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState("");

  const load = () => api.get("/pot-commun").then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);

  const claim = async (id) => {
    setBusy(id);
    try {
      await api.post(`/prospects/${id}/claim`);
      toast.success("C'est à toi ! Ce prospect t'est désormais attribué. 💪", { duration: 5000 });
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Impossible de récupérer ce prospect.");
      load();
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="p-8" data-testid="pot-commun-page">
      <Toaster position="top-right" richColors />
      <PageHeader title="Pot commun" subtitle="Leads disponibles — premier arrivé, premier servi" />

      <div className="bg-[#FBFAF7] border border-[#B8873A]/30 rounded-sm p-4 mb-6 text-sm text-slate-600 flex items-center gap-3">
        <Recycle className="w-5 h-5 text-[#B8873A] shrink-0" />
        Ces prospects n'ont pas été traités dans les temps et sont revenus dans le pot commun. Prends-en un, il devient le tien et tu repars sur un compteur neuf.
      </div>

      {list === null ? (
        <div className="p-10 text-center text-slate-500">Chargement…</div>
      ) : list.length === 0 ? (
        <EmptyState icon={Recycle} title="Le pot commun est vide" description="Tout est bien suivi, bravo à l'équipe !" testid="pot-commun-empty" />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="pot-commun-list">
          {list.map((p) => (
            <div key={p.id} className="bg-white border border-slate-200 rounded-sm p-4 hover:border-[#B8873A]/50 transition-colors" data-testid={`pot-commun-card-${p.id}`}>
              <button onClick={() => navigate(`/prospects/${p.id}`)} className="text-left group w-full">
                <div className="font-semibold text-[#111111] group-hover:text-[#B8873A] truncate">
                  {p.prenom} {p.nom}
                  <ChevronRight className="w-3.5 h-3.5 inline-block ml-0.5 -mt-0.5 opacity-0 group-hover:opacity-100" />
                </div>
                <div className="text-sm text-slate-500 truncate mt-0.5">{p.programme_recherche || "Projet non précisé"}</div>
                {p.ville && <div className="text-xs text-slate-400 flex items-center gap-1 mt-1"><MapPin className="w-3 h-3" />{p.ville}</div>}
              </button>
              <button
                onClick={() => claim(p.id)}
                disabled={busy === p.id}
                data-testid={`claim-btn-${p.id}`}
                className="mt-3 w-full flex items-center justify-center gap-2 text-sm font-semibold px-3 py-2 rounded-sm bg-[#111111] text-white hover:bg-slate-800 disabled:opacity-50"
              >
                <Hand className="w-4 h-4" /> {busy === p.id ? "…" : "Je le prends"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
